import { ResourcesView } from './Resources.view'

const Resources = () => {
  return <ResourcesView />
}

export { Resources }
